import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

import { IDriver } from '@/modules/driver/model/driver';
import { Icon } from '@src-common/view/components/Icon';

import s from './BlockInfo.module.css';

interface IProps {
  blockInfo: IDriver['blockInfo'];
}

const BlockInfo = ({ blockInfo }: IProps) => {
  if (blockInfo === undefined) {
    return null;
  }

  return (
    <div className={s.root}>
      <Icon icon="lock" className={s.icon} size={'24px'}></Icon>
      <div>
        <FormattedMessage
          defaultMessage="Blocked"
          id="Veo+8M"
          description="driver block info, when blocked"
        />
        {blockInfo.blockedAt && (
          <>
            {': '}
            <FormattedDate value={blockInfo.blockedAt} />{' '}
            <FormattedTime value={blockInfo.blockedAt} />
          </>
        )}
      </div>
      <div>
        <FormattedMessage defaultMessage="Reason" id="MsJ5yw" description="driver block info" />
        {': '}
        {blockInfo.reason}
      </div>
      {blockInfo.notes && (
        <div>
          <FormattedMessage defaultMessage="Message" id="aOdLtg" description="driver block info" />
          {': '}
          {blockInfo.notes}
        </div>
      )}
    </div>
  );
};

export { BlockInfo };
